import React from 'react'

import { Box, Input, Table, Text } from '@superlogica/design-system'
import { Search } from '@superlogica/design-system/Icons/superlogica'
import Pagination from 'components/Pagination/Pagination'
import { BoxTabTable, BoxTitleTable } from 'styles/global-style'


const View = ({ isLoading, isError, tableDataFatura, columns, refetch, setSingleFatura ,  totalItems, itemsPerPage,setCurrentPage,currentPage}) => {

  return (
    <>
      <BoxTabTable
        border
        borderColor="neutral300"
        bgColor="neutral0"
        paddingSize="xs"
        radius="md"
        className="flex align-center"
      >
        <BoxTitleTable paddingSize="none">
          <Text className="mr-xxxs">Faturas</Text>
          <Text color="neutral400" size="body02">
            {`Exibindo ${tableDataFatura.length}`}
          </Text>
        </BoxTitleTable>

        <Box paddingSize="none" className="ml-auto flex align-center">
          <Input
            className="ml-xxxs"
            name="search"
            type="text"
            label="Buscar..."
            onChange={(e) => {
              setSingleFatura(e.target.value)
            }}
            rightIcon={<Search />}
          />
        </Box>
      </BoxTabTable>
      <Box border borderColor="neutral300" bgColor="neutral0" paddingSize="none" radius="xs">
        <Table
          data={tableDataFatura}
          columns={columns}
          tableName="faturas"
          retry={refetch}
          error={isError}
          loading={isLoading}
        />
      </Box>
      <BoxTabTable
        border
        borderColor="neutral300"
        bgColor="neutral0"
        paddingSize="xxs"
        radius="md"
        className="flex align-center"
      >
      <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />
      </BoxTabTable>
    </>
  )
}

export default View
